// @flow

import React from 'react';
import { connect } from 'react-redux';
import Button from '../../../../../button';
import {
  getMailOfferButtonText,
  getOrderLeaseObjectButtonText,
} from '../../../../../../store/configuratorSettings/selectors';
import {
  getOrderLink,
} from '../../../../../../store/pdb/selectors';
import { ActionsWrapper } from './actions.styled';
import withOnClickValidation from '../../../../../withOnClickValidation';

const OrderButton = withOnClickValidation(Button);

type StateProps = {|
  orderButtonLabel: string,
  orderButtonLink: string,
  mailButtonLabel: string,
|};

type Props = StateProps;

const Actions = ({
  mailButtonLabel,
  orderButtonLabel,
  orderButtonLink,
}: Props) => (
  <ActionsWrapper>
    {orderButtonLink && mailButtonLabel && ([
      <OrderButton
        key="mailbutton"
        fullWidth
        caret
        variant="ghost"
        color="secondary"
        size="small"
        href={`${orderButtonLink}?offer=true`}
      >
        {mailButtonLabel}
      </OrderButton>,
    ])}
    {orderButtonLink && ([
      <OrderButton
        key="orderbutton"
        fullWidth
        caret
        href={orderButtonLink}
        size="small"
        hasMargin={false}
      >
        {orderButtonLabel}
      </OrderButton>,
    ])}
  </ActionsWrapper>
);

const mapStateToProps = (state): StateProps => ({
  mailButtonLabel: getMailOfferButtonText(state),
  orderButtonLink: getOrderLink(state),
  orderButtonLabel: getOrderLeaseObjectButtonText(state),
});

export default connect<Props, any, StateProps, any, any, any>(mapStateToProps)(Actions);
